import type { PImage } from '../../engine/aliases'
import type { IDeadish, IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { l } from '../../lib/imports'
import type { ISpring } from '../../lib/spring'
import { spring } from '../../lib/spring-sidecar'
import { common } from '../../main/common-sidecar'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import type { IStevieText2 } from '../../uiParts/stevieTexts2'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageLayers } from './voyageLayers-sidecar'

export const mouseCursorUpdateTime = 1 / 10

export interface IMultiplayerCursor extends IEntity, IDeadish {
  multiId: number
  imageCursor: PImage
  imageSelected: PImage
  crewSelected: IVoyageCrew | null

  textCursor: IStevieText2
  textSelected: IStevieText2

  // sx: number
  // sy: number
  // tx: number
  // ty: number

  springX: ISpring
  springY: ISpring

  updateTimer: number
  hideTimer: number
  isHidden: boolean
}

const objs: IMultiplayerCursor[] = []
export function getAll() {
  return objs
}

export function findByMultiId(multiId: number) {
  return l.find(getAll(), (c) => c.multiId == multiId) || null
}
export function findByMultiIdSafe(multiId: number) {
  let cur = findByMultiId(multiId)
  if (!cur) {
    cur = create(multiId)
  }
  return cur
}

export function create(multiId: number): IMultiplayerCursor {
  let frame = sprites.voyTileCursor[0]
  let imageCursor = spritesUtil.createImage(
    voyageLayers.getLayers().shipAbove,
    frame,
  )
  imageCursor.tint = voyageColors.red

  let imageSelected = spritesUtil.createImage(
    voyageLayers.getLayers().shipAbove,
    frame,
  )
  imageSelected.tint = voyageColors.purple

  let textCursor = stevieTexts2.create(
    echoFonts.getData().font4,
    0,
    0,
    voyageLayers.getLayers().shipAbove,
  )
  stevieTexts2.setScale(textCursor, 4)
  stevieTexts2.setText(textCursor, '' + multiId)

  let textSelected = stevieTexts2.create(
    echoFonts.getData().font4,
    0,
    0,
    voyageLayers.getLayers().shipAbove,
  )
  stevieTexts2.setScale(textSelected, 4)
  stevieTexts2.setText(textSelected, '' + multiId)

  let obj: IMultiplayerCursor = {
    id: -1,
    idLoaded: -1,
    multiId,
    isDead: false,
    eType: 'voy-misc',
    imageCursor: imageCursor,
    imageSelected,
    crewSelected: null,
    textCursor: textCursor,
    textSelected,
    springX: spring.create(),
    springY: spring.create(),
    // sx: 0,
    // sy: 0,
    // tx: 0,
    // ty: 0,
    updateTimer: 0,
    hideTimer: 0,
    isHidden: false,
  }
  objs.push(obj)

  spring.setDef(obj.springX, spring.defTight())
  spring.setDef(obj.springY, spring.defTight())

  return obj
}

export function moveToXY(obj: IMultiplayerCursor, x: number, y: number) {
  obj.imageCursor.x = x
  obj.imageCursor.y = y
  stevieTexts2.moveTo(obj.textCursor, x + 32, y)
}

export function kill(obj: IMultiplayerCursor) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(objs, (c) => {
    kill(c)
  })
  removeDead()
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  removeDead()
}
export function removeDead() {
  entitiesUtils.removeDead(objs, (c) => {
    c.imageCursor.destroy()
  })
}
function update(obj: IMultiplayerCursor) {
  let dt = common.getUpdateDelta()
  obj.updateTimer += dt
  obj.hideTimer += dt

  if (obj.hideTimer > 5) {
    obj.isHidden = true
  } else {
    obj.isHidden = false
  }
  obj.imageCursor.visible = !obj.isHidden
  stevieTexts2.setVisible(obj.textCursor, !obj.isHidden)

  spring.update(obj.springX, dt)
  spring.update(obj.springY, dt)

  // let t = mathUtils.clamp(obj.updateTimer / mouseCursorUpdateTime, 0, 1)
  // let x = mathUtils.lerp(obj.sx, obj.tx, t)
  // let y = mathUtils.lerp(obj.sy, obj.ty, t)
  moveToXY(obj, obj.springX.position, obj.springY.position)

  if (obj.crewSelected) {
    obj.imageSelected.visible = !obj.isHidden
    obj.imageSelected.x = obj.crewSelected.x
    obj.imageSelected.y = obj.crewSelected.y

    stevieTexts2.moveTo(
      obj.textSelected,
      obj.crewSelected.x + 32,
      obj.crewSelected.y,
    )
    stevieTexts2.setVisible(obj.textSelected, !obj.isHidden)
  } else {
    obj.imageSelected.visible = false
    stevieTexts2.setVisible(obj.textSelected, false)
  }
}

export function networkRecieveSelectCrew(
  obj: IMultiplayerCursor,
  cr: IVoyageCrew | null,
) {
  obj.crewSelected = cr
  obj.hideTimer = 0
}

export function networkRecieveStartLerpToXY(
  obj: IMultiplayerCursor,
  x: number,
  y: number,
) {
  // obj.sx = obj.image.x
  // obj.sy = obj.image.y
  // obj.tx = x
  // obj.ty = y

  obj.springX.target = x
  obj.springY.target = y
  obj.updateTimer = 0
  obj.hideTimer = 0
}

export function setName(obj: IMultiplayerCursor, name: string) {
  stevieTexts2.setText(obj.textCursor, name)
  stevieTexts2.setText(obj.textSelected, name)
}
